module.exports = {
  appUrl: 'https://www.groovehq.com/',
  widgetUrl: 'https://widget-cluster.production.groovehq.com',
  appDomain: 'groovehq.com',
  kbProxyDomain: 'hosting.groovehq.help',
  api_url: 'https://api.groovehq.com',
  graphql_url: 'https://graphql.groovehq.com/graphql',
  app_graphql_url: 'https://api.groovehq.com/v2/graphql',
  report_url: 'https://graphql.groovehq.com/reports',
  embeddable_cards_url: 'https://graphql.groovehq.com/embeddable_cards/proxy',
  realtime_url: 'realtime.groovehq.com',
  s3_url: 's3.amazonaws.com',
  vapidPublicKey:
    'BNeZTrpheVt1AqrEWUBRMIa3_g-5KrW3Gf63qPgNKBTmYiB48dCol4y6QqxQtbT0xsMwyjM9QnuqGX8nq2diEnM',
  stripePublicKey: 'pk_live_TUyxO0NZ4mGfVntGxql5FC1900Lgtmu1Qs',
  filestackKey: 'AbnxTnzehQ4KY9hgqQ767z',
  filestackRegion: 'us-east-1',
  filestackBucket: 'groove-filestack-production',
  showReports: true,
  showSettings: true,
  api_concurrency: 20,
  gtm_segment: 'Application',
  gtm_version: 'beta',
  gtm_containerid: 'GTM-MQ94GV3',
  gtm_auth: 'gTuZYzA0PueTz4F77TZkNA',
  gtm_preview: 'env-2',
  google_recaptcha_site_key: '6Lf8nH0UAAAAAFSIpT4Ylg1p4qqSswMEBmAuAFeO',
  integrationsApiUrl: 'https://integrations.groovehq.com',
  integrationsApiConcurrency: 4,
  githubAppName: 'groovehq',
  chatServerUrl: 'https://chat-server-cluster.production.groovehq.com',
  facebookMessengerUrl: 'https://business.facebook.com/latest/inbox/all',
  chatIdentityServerUrl: 'https://vector.im',
  chatFileSizeLimits: {
    // in bytes
    matrix: 25 * 1024 * 1024, // 25 MB
    facebook: 25 * 1024 * 1024, // 25 MB
  },
  emojiWidth: 280,
  emojiHeight: 399,
  uploaderUrl: 'https://uploader.groovehq.com',
  trialDays: 7,
  sygnalServerUrl: 'http://sygnal.default.svc.cluster.local',
  disableSW: process.env.OFFLINE_RUNTIME === 'off',
  oauthClientId:
    '540e86522262e7b24f72a67786e6d6c016c63f243190a2402b8cf73cb0b58751',
}
